const prefixCls = 'web.invoice.';

/**
 * 发货模块国际化资源
 */
export const localesInvoice = {
  // 表格列名
  [prefixCls + 'table.column.packageNumber']: {
    zh_CN: '装箱号',
    en_GB: 'Package Number',
  },
  [prefixCls + 'table.column.country']: {
    zh_CN: '国家',
    en_GB: 'Country',
  },
  [prefixCls + 'table.column.date']: {
    zh_CN: '发货日期',
    en_GB: 'Shipping Date',
  },
  [prefixCls + 'table.column.fbnDate']: {
    zh_CN: '送仓日期',
    en_GB: 'FBN Date',
  },
  [prefixCls + 'table.column.total']: {
    zh_CN: '总数',
    en_GB: 'Total',
  },
  [prefixCls + 'table.column.label']: {
    zh_CN: '标签',
    en_GB: 'Label',
  },
  [prefixCls + 'table.column.expressCompany']: {
    zh_CN: '快递公司',
    en_GB: 'Express Company',
  },
  [prefixCls + 'table.column.expressNo']: {
    zh_CN: '快递单号',
    en_GB: 'Express No',
  },
  [prefixCls + 'table.column.remarks']: {
    zh_CN: '备注',
    en_GB: 'Remarks',
  },
  [prefixCls + 'table.column.actions']: {
    zh_CN: '操作',
    en_GB: 'Actions',
  },

  // 搜索和筛选
  [prefixCls + 'filter.searchPlaceholder']: {
    zh_CN: '搜索装箱号',
    en_GB: 'Search Package Number',
  },
  [prefixCls + 'filter.country']: {
    zh_CN: '国家',
    en_GB: 'Country',
  },

  // 按钮和操作
  [prefixCls + 'action.createInvoice']: {
    zh_CN: '新建发货单',
    en_GB: 'New Invoice',
  },
  [prefixCls + 'action.skuRelation']: {
    zh_CN: 'SKU关联',
    en_GB: 'SKU Relation',
  },

  // 确认提示
  [prefixCls + 'confirm.delete']: {
    zh_CN: '确定删除此发货记录?',
    en_GB: 'Are you sure to delete this invoice?',
  },

  // 错误信息
  [prefixCls + 'error.fetchFailed']: {
    zh_CN: '获取发货数据失败',
    en_GB: 'Failed to fetch invoice data',
  },
  [prefixCls + 'error.createFailed']: {
    zh_CN: '创建发货记录失败',
    en_GB: 'Failed to create invoice record',
  },
  [prefixCls + 'error.updateFailed']: {
    zh_CN: '更新发货记录失败',
    en_GB: 'Failed to update invoice record',
  },
  [prefixCls + 'error.deleteFailed']: {
    zh_CN: '删除发货记录失败',
    en_GB: 'Failed to delete invoice record',
  },

  // 表单相关
  [prefixCls + 'modal.editTitle']: {
    zh_CN: '编辑发货记录',
    en_GB: 'Edit Invoice',
  },
  [prefixCls + 'form.packageNumber']: {
    zh_CN: '装箱号',
    en_GB: 'Package Number',
  },
  [prefixCls + 'form.country']: {
    zh_CN: '国家',
    en_GB: 'Country',
  },
  [prefixCls + 'form.date']: {
    zh_CN: '日期',
    en_GB: 'Date',
  },
  [prefixCls + 'form.total']: {
    zh_CN: '总数',
    en_GB: 'Total',
  },
  [prefixCls + 'form.label']: {
    zh_CN: '标签',
    en_GB: 'Label',
  },
  [prefixCls + 'form.expressCompany']: {
    zh_CN: '快递公司',
    en_GB: 'Express Company',
  },
  [prefixCls + 'form.expressName']: {
    zh_CN: '快递公司',
    en_GB: 'Express Name',
  },
  [prefixCls + 'form.remarks']: {
    zh_CN: '备注',
    en_GB: 'Remarks',
  },
  [prefixCls + 'form.remarksPlaceholder']: {
    zh_CN: '请输入备注',
    en_GB: 'Enter remarks',
  },
};
